import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
  grid-row: 1/2;
  padding:${({ agents }) => agents ? '20px 20px 10px 20px' : '20px 20px 24px 20px'};
`;
Header.displayName = 'Header';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${({ isOutsideWs }) => isOutsideWs ? '0px' : 'auto'};
`;
Wrapper.displayName = 'Wrapper';

export const Separator = styled.div`
  height: 16px;
  border-left: solid 1px #3e617d;
  transform: rotate(22deg);
  margin-right: 9px;
`;
Separator.displayName = 'Separator';
